export default "__VITE_ASSET__BnZ3sxAW__"